import React, { useState } from 'react'
import { Icon } from '@abw/badger-ui'

const Menu = ({children}) => {
  const [menuVisible, setMenuVisible] = useState(false);
  return <>
    <Icon
      name="menu"
      className="menu-trigger larger"
      onClick={() => setMenuVisible(! menuVisible)}
    />
    <div className={`menu ${menuVisible ? 'visible' : ''}`}>
      {children}
    </div>
  </>
}

export default Menu